module.exports = __webpack_public_path__ + "static/img/geotap-lucre-games-thumbnail.9b86c6c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/geotap-game/geotap-lucre-games-thumbnail.jpg
// module id = bLv7
// module chunks = 0